<template>
    <div>
        <div v-if="!dialogVisible">
            <div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">打卡明细查询</div>
            <el-row style="margin-top: 9px;">
                <div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

                    <el-row>

                        <!-- 左侧组织架构 --> 
                        <el-col :span="4" style="background-color: #f7f8fa; height: 750px;">
                            <Structure ref="Structure" @parentFind="Find" :condition="condition"></Structure>
                        </el-col>

                        <!-- 右侧列表 -->
                        <el-col :span="20">

                            <el-row style="padding-left: 46px; padding-top: 40px;">

                                <!-- <el-col :span="5">
                                    <span>所在职位</span>
                                    <el-select v-model="condition.post_id" placeholder="全部"
                                        style="width: 70%; margin-left: 10px;" clearable filterable>
                                        <el-option v-for="item in postList" :key="item.id" :label="item.post_name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-col> -->

                                <el-col :span="5">
                                    <span style="margin-left: 10px;">姓名</span>
                                    <el-input v-model="condition.staff_name" placeholder="请输入姓名"
                                        style="width: 70%; margin-left: 10px;"></el-input>
                                </el-col>

                                <el-col :span="9">
                                    <span>考勤时间</span>
                                    <el-date-picker v-model="condition.create_time" type="date" placeholder="请选择" value-format="yyyy-MM-dd"
                                        style="margin-left: 10px;">
                                    </el-date-picker>
                                </el-col>

                                <el-col :span="4">
                                    <el-button
                                        style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                                        @click="Find">
                                        查询</el-button>
                                </el-col>
                            </el-row>

                            <el-row style="margin: 0px 2%; margin-top: 50px;">
                                <el-row>
                                    <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
                                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData"
                                        height="540" tooltip-effect="dark" style="width: 100%;"
                                        @selection-change="handleSelectionChange">
                                        <el-table-column type="selection" width="55">
                                        </el-table-column>
                                        <el-table-column align="center" label="序号" width="50">
                                            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                                        </el-table-column>
                                        <el-table-column prop="organize_name" align="center" width="250px" label="组织架构"></el-table-column>
                                        <el-table-column prop="staff_name" align="center" width="120px" label="姓名"></el-table-column>
                                        <el-table-column prop="post_name" align="center" label="职位"></el-table-column>
                                        <el-table-column prop="start_work" align="center" width="150px" label="上班时间"></el-table-column>
                                        <el-table-column prop="knock_off" align="center" width="150px" label="下班时间"></el-table-column>
                                        <el-table-column prop="is_clockIn_place" align="center" label="是否迟到"></el-table-column>
                                        <el-table-column prop="is_clockIn_state" align="center" label="是否早退"></el-table-column>
                                    </el-table>
                                </el-row>
                                <el-row style="margin-top: 10px; text-align: center;">
                                    <el-pagination background @current-change="handleCurrentChange"
                                        :page-size="page_size" layout=" prev, pager, next, jumper" :total="total">
                                    </el-pagination>
                                </el-row>
                            </el-row>

                        </el-col>
                    </el-row>

                </div>
            </el-row>
        </div>

        <!-- <div v-if="dialogVisible">
            <edit ref="edit"></edit>
        </div> -->

    </div>
</template>

<script>
    import Structure from "../../utils/structure/structure.vue";

    import axios from "axios";
    export default {
        components: {
            Structure: Structure,
        },
        data() {
            return {
                //列表相关
                page_num: 1,
                page_size: 10,
                total: 0,
                tableData: [],

                //页面相关
                dialogVisible: false,

                //职位下拉
                // postList: [],

                //条件
                condition: {
                    project_id: "",
                    flag: "",
                    post_id: "",
                    staff_name: "",
                    induction_time: "",
                    create_time:this.$globals.getNowTime(),
                },

                //详情
                form: {
                    id: '',
                    staff_id:'',
                    staff_name:'',
                    start_work:'',
                    knock_off:'',
                    clockIn_place:'',
                    clockIn_state:'',
                },

                //复选框ids
                ids: [],
            };
        },
        methods: {
            Return() {
                this.dialogVisible = false;
                this.Find();
            },
            //查询
			async Find() {
                if(this.condition.create_time === '' || this.condition.create_time === null || this.condition.create_time === undefined){
                    this.condition.create_time = this.$globals.getNowTime()
                }
				var url = '/clockIn/find';
				var record = {
					page_num: this.page_num,
                    page_size: this.page_size,
                    staff_name: this.condition.staff_name,
                    create_time: this.condition.create_time,
                    organize_ids: this.condition.project_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
                }
			},
            //分页
            handleCurrentChange(val) {
                this.page_num = val
                this.Find();
            },
            //详情页面
            // Edit(e) {
            //     this.from.id = e;
            //     this.dialogVisible = true;
            // },

        },
        async created() {
            this.Find();
            //初始化职位下拉
            // var postList = await this.$globals.AxiosPost("post/selectFind", {});
            // this.postList = postList.data;
        }
    }
</script>

<style scoped="scoped">
    >>>.el-button:hover {
        background-color: #FFFFFF;
    }

    >>>.el-button:focus {
        background-color: #FFFFFF;
    }

    >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #006E4B;
    }

    >>>.el-input__inner:focus {
        border-color: #006E4B;
    }

    >>>.el-select .el-input.is-focus .el-input__inner {
        border-color: #006E4B;
    }

    >>>.el-checkbox__input.is-checked .el-checkbox__inner,
    >>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #006E4B;
        border-color: #006E4B;
    }

    >>>.el-checkbox__inner:hover {
        border-color: #006E4B;
    }
    >>>.el-tree-node.is-expanded>.el-tree-node__children {
		display: inline;
	}
</style>



// WEBPACK FOOTER //
// dkmx.vue?225a26a2